import React, {FC, useEffect} from 'react';
import styled, {useTheme} from "styled-components";
import PropTypes from "prop-types";

import {isFintro} from "helpers/domain";
import {Header} from "containers/Header";

const ApplicationWrapper = styled.div`
    display: block;

    ${({theme}) => theme.media.desktop`
        position: relative;
        top: -54px;
        display: table;
        max-width: 76.25em;
        margin: 0 auto;
        border-radius: 8px;
        box-shadow: 1px 2px 14px 0 rgba(0, 0, 0, .08);
        background-color: #fff;
    `};
`;

const PageContainerPropTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}
type PageContainerProps = PropTypes.InferProps<typeof PageContainerPropTypes>;

export const PageContainer: FC<PageContainerProps> = ({ children }: PageContainerProps) => {
    const theme = useTheme();

    useEffect(() => {
        if(!isFintro()) {
            return;
        }

        theme.update("kn")
    }, []);

    return (
        <>
            <Header />
            <ApplicationWrapper>
                <>
                    {children}
                </>
            </ApplicationWrapper>
        </>
    )
}
